import {useQuery} from "react-query";

import {
  QuicksightDashboard,
  QuicksightService,
} from "../../../services/QuicksightService";

export const useQuicksightCurrentUserDashboards = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) =>
  useQuery(
    "quicksightCurrentUserDashboards",
    async () => {
      const {data} = await QuicksightService.getCurrentUserDashboards();

      return data.dashboards as ReadonlyArray<QuicksightDashboard>;
    },
    {
      enabled,
    },
  );

export const UseQuicksightCurrentUserDashboards = ({
  children,
}: {
  children: (
    query: ReturnType<typeof useQuicksightCurrentUserDashboards>,
  ) => JSX.Element;
}) => children(useQuicksightCurrentUserDashboards());
